import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import mn from './locales/mn.json'
import ko from './locales/ko.json'
import ja from './locales/ja.json'
import es from './locales/es.json'
import hi from './locales/hi.json'
import id from './locales/id.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mn: { translation: mn },
      ko: { translation: ko },
      ja: { translation: ja },
      es: { translation: es },
      hi: { translation: hi },
      id: { translation: id },
    },
    lng:         localStorage.getItem('silkvoice-lang') ?? 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })

export default i18n
